<template>
  <div role="main" class="main">
    <section class="page-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <ul class="breadcrumb">
              <li class="active">Formulir Pendaftaran</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <modal height="auto" name="verification-confirm" @closed="setDefaultModal" adaptive>
        <div style="margin: 15px">
          <div class="alert alert-danger" v-show="$store.state.verification.verificationError">
            <p>{{ $store.state.verification.verificationErrorMsg }}</p>
          </div>
          <center>
            <pulse-loader style="margin: 15px" :loading="$store.state.verification.verificationLoading" color="#696969" size="10px"></pulse-loader>
          </center>
          <p>Pastikan data yang anda masukan adalah data yang benar. Jika anda melakukan verifikasi maka data tidak dapat mengubah data lagi</p>
          <button
            class="btn btn-primary pull-right"
            style="margin-top: 20px; margin-bottom: 15px"
            :disabled="$store.state.verification.verificationLoading"
            @click="verify">
            Finalisasi
          </button>
        </div>
      </modal>
      <div class="row">
        <div class="col-md-3">
          <sidebar/>
        </div>
        <div class="col-md-9">
          <flash-message></flash-message>
          <center>
            <pulse-loader style="margin: 15px" :loading="$store.state.formData.loading" color="#696969" size="10px"></pulse-loader>
          </center>
          <div v-show="!$store.state.auth.isMoment" class="alert alert-info">
            Mohon maaf saat ini bukan termasuk waktu pengisian data PMB
          </div>
          <form-wizard
            v-show="$store.state.auth.isMoment"
            title=""
            subtitle=""
            back-button-text="Kembali"
            next-button-text="Selanjutnya"
            finish-button-text="Finalisasi"
            color="#095F0F"
            ref="formWizard"
            step-size="sm"
            @on-change="onChangeTab"
            @on-complete="onComplete">
            <tab-content
              v-if="isFormGroupExist('data_diri')"
              title="Data Diri"
              :before-change="() => validate('stepDataDiri')">
              <data-diri ref="stepDataDiri"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_bapak')"
              title="Data Ayah"
              :before-change="() => validate('stepDataAyah')">
              <data-ayah ref="stepDataAyah"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_ibu')"
              title="Data Ibu"
              :before-change="() => validate('stepDataIbu')">
              <data-ibu ref="stepDataIbu"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_keluarga')"
              title="Data Keluarga"
              :before-change="() => validate('stepDataKeluarga')">
              <data-keluarga ref="stepDataKeluarga"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_kesehatan')"
              title="Data Kesehatan"
              :before-change="() => validate('stepDataKesehatan')">
              <data-kesehatan ref="stepDataKesehatan"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_organisasi')"
              title="Data Organisasi"
              :before-change="() => validate('stepDataOrganisasi')">
              <data-organisasi ref="stepDataOrganisasi"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_prestasi')"
              title="Data Prestasi"
              :before-change="() => validate('stepDataPrestasi')">
              <data-prestasi ref="stepDataPrestasi"/>
            </tab-content>
            <!-- <tab-content
              v-if="isFormGroupExist('data_wali')"
              title="Data Wali"
              :before-change="() => validate('stepDataWali')">
              <data-wali ref="stepDataWali" @on-validate-data-wali="onDataWaliValidate"/>
            </tab-content> -->
            <tab-content
              v-if="isFormGroupExist('data_riwayat_pendidikan_sebelumnya')"
              title="Pendidikan Sebelumnya (S1/D3)"
              :before-change="() => validate('stepDataRiwayatPendidikanSebelumnya')">
              <data-riwayat-pendidikan-sebelumnya ref="stepDataRiwayatPendidikanSebelumnya"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('riwayat_pendidikan_s2')"
              title="Pendidikan Sebelumnya (S2/S3)"
              :before-change="() => validate('stepDataRiwayatPendidikanS2')">
              <data-riwayat-pendidikan-s2
                ref="stepDataRiwayatPendidikanS2"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_penelitian')"
              title="Data Penelitian"
              :before-change="() => validate('stepDataPenelitian')">
              <data-penelitian ref="stepDataPenelitian"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_karya_tulis')"
              title="Data Karya Tulis">
              <data-karya-tulis ref="stepDataKaryaTulis"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_disertasi')"
              title="Data Rencana Disertasi"
              :before-change="() => validate('stepDataDisertasi')">
              <data-disertasi ref="stepDataDisertasi"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_sertifikasi')"
              title="Data Sertifikasi"
              :before-change="() => validate('stepDataSertifikasi')">
              <data-sertifikasi ref="stepDataSertifikasi"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_proposal_tesis')"
              title="Data Proposal Tesis"
              :before-change="() => validate('stepDataProposalTesis')">
              <data-proposal-tesis ref="stepDataProposalTesis"/>
            </tab-content>
            <tab-content
              v-if="isFormKhususExist()"
              title="Data Khusus"
              :before-change="() => validate('stepDataKhusus')">
              <data-khusus ref="stepDataKhusus" />
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_piljur')"
              title="Data Pilihan Jurusan"
              :before-change="() => validate('stepDataPilihanJurusan')">
              <data-pilihan-jurusan ref="stepDataPilihanJurusan"/>
            </tab-content>
            <tab-content
              v-if="isFormGroupExist('data_verifikasi')"
              title="Finalisasi">
              <data-verifikasi ref="stepVerifikasi"></data-verifikasi>
            </tab-content>
          </form-wizard>
          <div class="visible-xs">
            <div class="col-md-12">
              <h4 class="heading-primary"><i class="fa fa-bullhorn"></i> Pengumuman</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.pengumuman.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailPengumuman(item.id_pengumuman)"
                    style="cursor: pointer"
                    >{{ item.judul }}</a
                  >
                </li>
              </ul>
              <h4 class="heading-primary"><i class="fa fa-newspaper-o"></i> Artikel</h4>
              <ul class="nav nav-list mb-xlg sort-source">
                <li
                  v-for="item in $store.state.artikel.randomThree.filter(el => el)"
                  :key="item.id"
                >
                  <a
                    @click="() => goToDetailArtikel(item.id_berita)"
                    style="cursor: pointer"
                  >
                    {{ item.judul }}</a
                  >
                </li>
                <li>
                  <a @click="() => goToCardArtikel()" style="cursor: pointer">
                    <h6 class="heading-primary">
                      Selengkapnya...
                    </h6>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import TabDataDiri from './DataDiri'
import TabDataIbu from './DataIbu'
import TabDataAyah from './DataBapak'
import TabDataKeluarga from './DataKeluarga'
import TabDataKesehatan from './DataKesehatan'
import TabDataOrganisasi from './DataOrganisasi'
import TabDataPrestasi from './DataPrestasi'
import TabDataWali from './DataWali'
import TabDataRiwayatPendidikanSebelumnya from './DataRiwayatPendidikanSebelumnya'
import TabDataRiwayatPendidikanS2 from './RiwayatPendidikanS2'
import TabDataPenelitian from './DataPenelitian'
import TabDataKaryaTulis from './DataKaryaTulis'
import TabDataDisertasi from './DataDisertasi'
import TabDataSertifikasi from './DataSertifikasi'
import TabDataPilihanJurusan from './DataPilihanJurusan'
import TabDataProposalTesis from './DataProposalTesis'
import TabDataVerifikasi from './DataVerifikasi'
import TabDataKhusus from './DataKhusus'
import DataKeluarga from './DataKeluarga.vue'

export default {
  beforeCreate () {
    let verified = this.$store.getters.getVerificationData.verificationSuccess
    verified ? this.$router.push({name: 'KartuUjian'}) : this.$store.dispatch('getVerificationStatus')
  },
  mounted () {
    let verified = this.$store.getters.getVerificationData.verificationSuccess
    if (verified) {
      this.$router.push({name: 'KartuUjian'})
    } else {
      this.$store.getters.formData.length === 0 ? this.$store.dispatch('getFormData') : false
      this.$store.getters.catatanGrup.length === 0 ? this.$store.dispatch('getCatatanFormGrupData') : false
    }
  },
  components: {
    'form-wizard': FormWizard,
    'tab-content': TabContent,
    'data-diri': TabDataDiri,
    'data-ayah': TabDataAyah,
    'data-ibu': TabDataIbu,
    'data-keluarga': TabDataKeluarga,
    'data-kesehatan': TabDataKesehatan,
    'data-organisasi': TabDataOrganisasi,
    'data-prestasi': TabDataPrestasi,
    'data-wali': TabDataWali,
    'data-riwayat-pendidikan-sebelumnya': TabDataRiwayatPendidikanSebelumnya,
    'data-riwayat-pendidikan-s2': TabDataRiwayatPendidikanS2,
    'data-penelitian': TabDataPenelitian,
    'data-karya-tulis': TabDataKaryaTulis,
    'data-disertasi': TabDataDisertasi,
    'data-sertifikasi': TabDataSertifikasi,
    'data-pilihan-jurusan': TabDataPilihanJurusan,
    'data-proposal-tesis': TabDataProposalTesis,
    'data-verifikasi': TabDataVerifikasi,
    'data-khusus': TabDataKhusus,
    DataKeluarga
  },
  computed: {
    tabData () {
      return this.$refs['formWizard'].tabs
    }
  },
  methods: {
    isFormGroupExist (name) {
      return this.$store.getters.formGroupIsExist(name)
    },
    isFormKhususExist () {
      return this.$store.getters.formKhususIsExist()
    },
    onChangeTab (prevIndex, nextIndex) {
      let refName = this.getRefName(this.tabData[nextIndex].title)
      this.$refs[refName].initData()
      scroll(0, 0)
    },
    setDefaultModal () {
      this.$store.dispatch('closeModal')
    },
    validate (ref) {
      return this.$refs[ref].validate()
    },
    onComplete () {
      this.$modal.show('verification-confirm')
    },
    verify () {
      if (process.env.NODE_ENV !== 'test') {
        this.$store.dispatch('verifiy')
      }
    },
    getRefName (title) {
      switch (title) {
        case 'Data Diri':
          return 'stepDataDiri'
        case 'Data Keluarga':
          return 'stepDataKeluarga'
        case 'Data Ayah':
          return 'stepDataAyah'
        case 'Data Ibu':
          return 'stepDataIbu'
        case 'Data Kesehatan':
          return 'stepDataKesehatan'
        case 'Data Wali':
          return 'stepDataWali'
        case 'Pendidikan Sebelumnya (S1/D3)':
          return 'stepDataRiwayatPendidikanSebelumnya'
        case 'Pendidikan Sebelumnya (S2/S3)':
          return 'stepDataRiwayatPendidikanS2'
        case 'Data Penelitian':
          return 'stepDataPenelitian'
        case 'Data Karya Tulis':
          return 'stepDataKaryaTulis'
        case 'Data Rencana Disertasi':
          return 'stepDataDisertasi'
        case 'Data Sertifikasi':
          return 'stepDataSertifikasi'
        case 'Data Prestasi':
          return 'stepDataPrestasi'
        case 'Data Organisasi':
          return 'stepDataOrganisasi'
        case 'Data Proposal Tesis':
          return 'stepDataProposalTesis'
        case 'Data Pilihan Jurusan':
          return 'stepDataPilihanJurusan'
        case 'Data Khusus':
          return 'stepDataKhusus'
        case 'Verifikasi':
          return 'stepVerifikasi'
      }
    }
  }
}
</script>

<style>
  .required-label {
    margin-right: 10px;
    color: red
  }

  .error-label {
    color: red;
    margin-top: 10px;
    display:inline-block
  }

  .form-space {
    margin-top: 30px
  }

  .form-title {
    margin-bottom: 0px;
    color: #0088cc
  }
</style>



// WEBPACK FOOTER //
// src/page/register/Form.vue